import type { Ref } from "react";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
} from "@volca/ui/components/ui/empty";
import { Stack } from "@volca/ui/components/ui/stack";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import { StatementRenderer } from "@/payroll/ai-script/statement/statement-renderer";
import type { ComparisonStatementSide } from "./types";
export const StatementPane = ({
  heading,
  side,
  viewportRef,
}: {
  heading: string;
  side: ComparisonStatementSide | undefined;
  /** Driven by the other side, so both show the same part of the document. */
  viewportRef: Ref<HTMLDivElement>;
}) => (
  <Stack
    gap={0}
    align="stretch"
    direction="column"
    className="flex min-h-0 min-w-0 flex-col"
  >
    <p className="border-b border-line px-3 py-1 text-xs font-medium tracking-widest text-subtle uppercase">
      {heading}
    </p>
    {side?.issues.length ? (
      <div className="p-4 text-xs" role="alert">
        <p className="font-medium">This PayPack does not render.</p>
        <p className="mt-1 text-subtle">{side.issues.join(" ")}</p>
      </div>
    ) : (
      <div
        ref={viewportRef}
        className="flex min-h-0 flex-1 flex-col overflow-y-auto"
      >
        {/* The rail and this pane's own heading already say whose statement
            this is; the renderer's title would be a third copy. */}
        {!side && (
          <Empty className={emptyStateVariants({ layout: "collection" })}>
            <EmptyHeader>
              <EmptyDescription>
                No PayPack on this side of the comparison.
              </EmptyDescription>
            </EmptyHeader>
          </Empty>
        )}
        {side && (
          <StatementRenderer statement={side.statement} showTitle={false} />
        )}
      </div>
    )}
  </Stack>
);
